import Decimal from "decimal.js";

export const DECIMAL_PLACES_CRYPTO = 8;
export const NEAREST_CRYPTO = 0.00000001;
export const DECIMAL_PLACES_FIAT = 2;
export const NEAREST_FIAT = 0.01;

export const ZERO = new Decimal(0);

export function formatCurrency(value: Decimal, currencyCode: string): string {
    let valueFiat = value.toFixed(DECIMAL_PLACES_FIAT);
    let valueCrypto = value.toFixed(DECIMAL_PLACES_CRYPTO);
    switch (currencyCode) {
        case 'GBP':
            return `£${valueFiat}`;
        case 'AUD':
            return `$${valueFiat}`;
        case 'CAD':
            return `$${valueFiat}`;
        case 'CHF':
            return `${valueFiat} CHF`;
        case 'DKK':
            return `${valueFiat} kr`;
        case 'EUR':
            return `€${valueFiat}`;
        case 'NOK':
            return `${valueFiat} NOK`;
        case 'NZD':
            return `$${valueFiat}`;
        case 'PLN':
            return `${valueFiat} zł`;
        case 'SEK':
            return `${valueFiat} kr`;
        case 'USD':
            return `$${valueFiat}`;
        case 'MYR':
            return `${valueFiat} RM`;
        case 'BTC':
            return `${valueCrypto} BTC`;
        case 'BCH':
            return `${valueCrypto} BCH`;
        case 'ETH':
            return `${valueCrypto} ETH`;
        case 'LTC':
            return `${valueCrypto} LTC`;
        case 'ETC':
            return `${valueCrypto} ETC`;
        default:
            return `${value} ???`;
    }

}
